import axios from 'axios';

const state = () => {
    return {
        data: {},
    };
};

const getters = {
    getImage: (state) => {
        return (key) => {
            return state.data[key];
        };
    },
};

const mutations = {
    setImages(state, sounds) {
        state.data = sounds;
    },
};

const actions = {
    async loadImages({ commit }) {
        const response = await axios.get('data/images.json');

        commit('setImages', response.data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};